export const GIFTING_CART = {
    BOW_TIE: "portal/m/gifting-cart/gifting-cart-bow.png",
};

export const SAVINGS_BANNER_ANIMATION_DURATION = 1000;
